/**
 * CANDEIA AROMAS - CTA TRACKING & ENHANCEMENT
 * Monitora cliques em CTAs sem duplicar listeners
 */

(function() {
  'use strict';

  const CTA_CONFIG = {
    trackingEnabled: true,
    heroSelector: '.hero__content .button, .hero .button, .hero-button',
    productSelector: '.product-form__submit, .product-form .button',
    ctaAttr: 'data-candeia-cta-tracked',
    feedbackAttr: 'data-candeia-feedback-bound'
  };

  function determineCTAType(button) {
    if (!button) return 'cta';
    if (button.matches(CTA_CONFIG.productSelector) || button.closest('.product-form')) {
      return 'product_cta';
    }
    if (button.matches(CTA_CONFIG.heroSelector) || button.closest('.hero')) {
      return 'hero_cta';
    }
    return 'cta';
  }

  function safeTrack(eventName, payload) {
    if (window.gtag && typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }

    if (window.fbq && typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, payload);
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
  }

  function bindCTAButtons(root = document) {
    if (!CTA_CONFIG.trackingEnabled) return;

    const selectors = [CTA_CONFIG.heroSelector, CTA_CONFIG.productSelector].join(', ');
    const buttons = root.querySelectorAll(selectors);

    buttons.forEach((button) => {
      if (button.getAttribute(CTA_CONFIG.ctaAttr) === 'true') {
        return;
      }

      button.setAttribute(CTA_CONFIG.ctaAttr, 'true');
      button.addEventListener('click', function(event) {
        const target = event.currentTarget || event.target.closest('button, a');
        if (!target) return;

        const ctaType = determineCTAType(target);
        const ctaText = (target.textContent || '').trim();

        if (!ctaText) return;

        const eventData = {
          event_category: 'engagement',
          event_label: `cta_click_${ctaType}`,
          value: 1,
          cta_text: ctaText,
          cta_type: ctaType
        };

        safeTrack('cta_click', eventData);
      });
    });
  }

  function enhanceCTAFeedback(root = document) {
    const buttons = root.querySelectorAll('.button, button, a[role="button"]');

    buttons.forEach((button) => {
      if (button.getAttribute(CTA_CONFIG.feedbackAttr) === 'true') {
        return;
      }

      button.setAttribute(CTA_CONFIG.feedbackAttr, 'true');

      button.addEventListener('mousedown', function() {
        this.classList.add('is-active');
      });

      button.addEventListener('mouseup', function() {
        this.classList.remove('is-active');
      });

      button.addEventListener('mouseleave', function() {
        this.classList.remove('is-active');
      });

      button.addEventListener('touchstart', function() {
        this.style.opacity = '0.8';
      }, { passive: true });

      button.addEventListener('touchend', function() {
        this.style.opacity = '1';
      }, { passive: true });
    });
  }

  function initialize() {
    bindCTAButtons();
    enhanceCTAFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:reorder', initialize);
  }

  window.CandeiaUtils = window.CandeiaUtils || {};
  window.CandeiaUtils.trackCTA = (event, ctaType) => {
    if (!event || !event.currentTarget) return;
    safeTrack('cta_click', {
      event_category: 'engagement',
      event_label: `cta_click_${ctaType || 'cta'}`,
      value: 1,
      cta_text: (event.currentTarget.textContent || '').trim(),
      cta_type: ctaType || 'cta'
    });
  };
})();
